module.exports = __webpack_public_path__ + "img/mm-logo-branca.png";